var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleONotch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,19A7,7,0,0,1,9.67,5.41l.66,1.88a5,5,0,1,0,3.34,0l.66-1.88A7,7,0,0,1,12,19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleONotch);
export default __webpack_public_path__ + "static/1765983986/media/icon-circle-o-notch.a3011ac9b9f8c88821d42330dcbd1696.svg";
export { ForwardRef as ReactComponent };